module.exports = __webpack_public_path__ + "img/media-26.27083dca.png";